module.exports = __webpack_public_path__ + "img/30.9d8e981f.png";